var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 158,
    viewBox: "0 0 216 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 23.5,
    width: 134,
    height: 134,
    rx: 67,
    fill: "#8B91B9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6406 92.5513L103.845 100.756L124.357 80.2441",
    stroke: "#53587A",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4879 54.965C95.5221 51.4745 102.528 49.4769 110 49.4769C132.656 49.4769 151.023 67.8436 151.023 90.5C151.023 113.156 132.656 131.523 110 131.523C87.3433 131.523 68.9766 113.156 68.9766 90.5C68.9766 83.0281 70.9742 76.0224 74.4647 69.9882",
    stroke: "#53587A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.519 2.2147C167.655 1.72823 168.345 1.72823 168.481 2.2147L169.897 7.25683C169.944 7.42472 170.075 7.55593 170.243 7.60307L175.285 9.01861C175.772 9.15518 175.772 9.84482 175.285 9.98139L170.243 11.3969C170.075 11.4441 169.944 11.5753 169.897 11.7432L168.481 16.7853C168.345 17.2718 167.655 17.2718 167.519 16.7853L166.103 11.7432C166.056 11.5753 165.925 11.4441 165.757 11.3969L160.715 9.98139C160.228 9.84482 160.228 9.15518 160.715 9.01861L165.757 7.60307C165.925 7.55593 166.056 7.42472 166.103 7.25683L167.519 2.2147Z",
    fill: "#53587A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51861 58.2147C9.65518 57.7282 10.3448 57.7282 10.4814 58.2147L12.1161 64.0376C12.1633 64.2055 12.2945 64.3367 12.4624 64.3839L18.2853 66.0186C18.7718 66.1552 18.7718 66.8448 18.2853 66.9814L12.4624 68.6161C12.2945 68.6633 12.1633 68.7945 12.1161 68.9624L10.4814 74.7853C10.3448 75.2718 9.65518 75.2718 9.51861 74.7853L7.88387 68.9624C7.83673 68.7945 7.70552 68.6633 7.53762 68.6161L1.7147 66.9814C1.22823 66.8448 1.22823 66.1552 1.7147 66.0186L7.53762 64.3839C7.70552 64.3367 7.83673 64.2055 7.88387 64.0376L9.51861 58.2147Z",
    fill: "#53587A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.519 109.215C203.655 108.728 204.345 108.728 204.481 109.215L206.555 116.599C206.602 116.767 206.733 116.898 206.901 116.945L214.285 119.019C214.772 119.155 214.772 119.845 214.285 119.981L206.901 122.055C206.733 122.102 206.602 122.233 206.555 122.401L204.481 129.785C204.345 130.272 203.655 130.272 203.519 129.785L201.445 122.401C201.398 122.233 201.267 122.102 201.099 122.055L193.715 119.981C193.228 119.845 193.228 119.155 193.715 119.019L201.099 116.945C201.267 116.898 201.398 116.767 201.445 116.599L203.519 109.215Z",
    fill: "#53587A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/success-img.083977654adde320ee95d3aa827ef275.svg";
export { ForwardRef as ReactComponent };